import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from 'src/components/Button';
import PittaLogoWithTextSVG from 'src/assets/images/PittaLogoWithText.svg';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { selectAuthStatus, globalReset } from 'src/features/login/authSlice';
import { getAuthorizes, removeAuthorize } from 'src/storage/authorize';
import { useEndSessionMutation } from 'src/api/authApi';
import { routePathConfig } from 'src/routes/config';
import { Background, Card, Title, Description, Hint } from '../styled';

const Landing = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const authStatus = useAppSelector(selectAuthStatus);
  const session = getAuthorizes()[0];
  const [endSession] = useEndSessionMutation();

  useEffect(() => {
    if (authStatus !== 'authenticated') {
      navigate(routePathConfig.login);
    }
  }, [authStatus, navigate]);

  const handleLogout = async () => {
    // Only the server can clear an HttpOnly cookie, so signing out is a request,
    // not a local operation. Local state is cleared regardless of the outcome:
    // leaving the user on a page that claims they are signed in would be worse,
    // and the endpoint succeeds even without a valid session.
    try {
      await endSession().unwrap();
    } catch {
      // Fall through to clearing local state.
    }
    if (session) {
      removeAuthorize(session.account);
    }
    dispatch(globalReset());
    navigate(routePathConfig.login);
  };

  if (authStatus !== 'authenticated' || !session) {
    return null;
  }

  return (
    <Background>
      <Card>
        <img src={PittaLogoWithTextSVG} alt="Pitta" height={48} />
        <Title>帳號管理中心</Title>
        <Description>這是您的 Pitta 帳號管理頁面。您已成功登入管理中心。</Description>
        <Hint style={{ marginTop: '16px', fontWeight: 'bold' }}>目前帳號：{session.account}</Hint>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleLogout}
          sx={{ marginTop: '24px', width: '100%', fontWeight: 700 }}
        >
          登出 (Logout)
        </Button>
      </Card>
    </Background>
  );
};

export default Landing;
